import { CircleCancelIcon, CircleCheckmarkIcon } from '@app/assets/icons'
import { Box, SxProps } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { CustomButton } from './buttons'
import {
	CustomDurationPicker,
	CustomDurationPickerProps,
} from './CustomDurationPicker'
import { CustomIconFromValue } from './CustomIconFromValue'
import { DurationText } from './DurationText'
import theme from '@app/lib/materialui/theme'

interface EditableDurationTextProps extends CustomDurationPickerProps {
	sx?: SxProps
	isEditable?: boolean
}

const EditableInnerDurationText: FC<EditableDurationTextProps> = ({
	onChange,
	value = 0,
	...otherProps
}) => {
	const [isEditing, setIsEditing] = useState(false)
	const [duration, setDuration] = useState(value)

	useEffect(() => {
		setDuration(value)
	}, [value])

	const toggleDurationEditing = () => {
		setIsEditing(!isEditing)
	}

	const onDurationSubmit = () => {
		if (onChange) {
			onChange(duration)
		}

		toggleDurationEditing()
	}

	return isEditing ? (
		<Box alignItems="center" display="flex">
			<CustomDurationPicker
				innerTextFieldSx={{
					maxWidth: theme.spacing(18),
				}}
				onChange={setDuration}
				value={duration}
				size="small"
			/>
			<Box display="flex" alignItems="center" ml={1} gap={1}>
				<CustomButton
					style={{
						fontSize: '1rem',
						height: '36px',
						paddingTop: 10,
						minWidth: 0,
					}}
					onClick={onDurationSubmit}
					size="small"
				>
					<CircleCheckmarkIcon fill="white" />
				</CustomButton>

				<CustomButton
					style={{
						fontSize: '1rem',
						height: '36px',
						paddingTop: 10,
						minWidth: 0,
					}}
					onClick={() => {
						setDuration(value)
						toggleDurationEditing()
					}}
					size="small"
				>
					<Box
						sx={{
							transform: 'scale(0.82)',
						}}
					>
						<CircleCancelIcon fill="white" />
					</Box>
				</CustomButton>
			</Box>
		</Box>
	) : (
		<Box alignItems="center" display="flex">
			<DurationText
				sx={otherProps.sx}
				durationInSeconds={duration || 0}
			/>
			<Box
				sx={{
					cursor: 'pointer',
				}}
				ml={1}
				onClick={toggleDurationEditing}
			>
				<CustomIconFromValue icon="svg pencil" />
			</Box>
		</Box>
	)
}

export const EditableDurationText: FC<EditableDurationTextProps> = ({
	isEditable = false,
	value,
	...otherProps
}) => {
	if (!isEditable) {
		return (
			<DurationText
				durationInSeconds={value || 0}
				sx={{
					...otherProps.sx,
					paddingRight: '29px',
				}}
			/>
		)
	}

	return <EditableInnerDurationText value={value} {...otherProps} />
}
